import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IOperative } from "../../../message-models/operative.interface";
import { OperativeInfo } from "../../../domain-model/operative-info.class";
import { IJobTitleInfo } from "../../../message-models/job-title.interface";
import { IJobLevelInfo } from "../../../message-models/job-level.interface";
import { IRiskInfo } from "../../../message-models/risk-info.interface";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { consts } from "../../../common/modals/consts";
import { UntypedFormControl, Validators } from '@angular/forms';
import { IEmploymentStatus } from '../../../message-models/employment-status.interface';
import { IOperativeTypeInfo } from '../../../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';

@Component({
  selector: 'app-operative-editor-modal',
  templateUrl: './operative-editor-modal.component.html',
  styleUrls: ['./operative-editor-modal.component.scss']
})
export class OperativeEditorModalComponent implements OnInit {
  @Input() heading: string = "Add New Operative";
  @Input() editing: boolean = false;
  @Input() operative: OperativeInfo = new OperativeInfo();
  @Input() isNewOperative: boolean = false;
  @Input() allJobTitles: IJobTitleInfo[] = [];
  @Input() allCompanyJobTitles: ICompanyJobTitle[] = [];
  @Input() allJobLevels: IJobLevelInfo[] = [];
  @Input() allOperativeTypes: IOperativeTypeInfo[] = [];
  @Input() allBusinessUnits: IBusinessUnitInfo[] = [];
  @Input() allRisks: IRiskInfo[] = [];
  @Input() allEmploymentStatuses: IEmploymentStatus[] = [];
  @Output() saveOperativeRequested: EventEmitter<IOperative> = new EventEmitter<IOperative>();
  @Output() cancelRequested: EventEmitter<any> = new EventEmitter<any>();
  showingHelp: boolean = false;
  helpMessage: string = 'With this screen you can add new operative to your company';
  submitted: boolean;

  constructor(private modalRef: DynamicDialogRef) { }

  ngOnInit(): void {
  }

  saveOperative() {
    if (!this.operative.isValid || !this.validateEmail(this.operative.emailAddress)) {
      this.submitted = true;
      return;
    }
    this.saveOperativeRequested.emit(this.operative)
    this.modalRef.close();
  }

  editOperative() {
    this.editing = false;
  }

  cancelClicked() {
    this.cancelRequested.emit();
    this.modalRef.close();
  }

  getHeadingFromOperative() {
    if (!this.operative?.id || this.operative.id === consts.emptyGuid)
      return "Add a New Operative";

    return "Update existing Operative";
  }
  validateEmail(email: string) {
    if (email !== '') {
      let emailAddress = new UntypedFormControl(email,
        [Validators.email, Validators.pattern("^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$")]);
      return emailAddress.valid;
    } else {
      return true;
    }
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }
}
